import { Expose, Type } from 'class-transformer';
import { SurveyLinkElement } from '@/models/survey-elements/link-element';
import { SurveyElement } from './element';

class FillingElements {
  @Expose()
  key!: string;

  @Expose()
  @Type(() => SurveyLinkElement)
  element!: SurveyLinkElement;
}
export class CheckboxElement extends SurveyElement {
  @Expose()
  label!: string;

  @Expose({ name: 'filling_elements' })
  @Type(() => FillingElements)
  fillingElements!: FillingElements[];
}
